import { useState } from 'react'

import {
  Box,
  Button,
  Chevron,
  CollapsableCard,
  Icon,
  Text,
  Touchable,
} from '@factorialco/deprecated-design-system'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import { AtsCandidateEmailActionFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { delayLabel, sendFromLabel } from 'modules/ats/lib/utils/candidateEmailActions'

interface Props {
  candidateEmailAction: AtsCandidateEmailActionFragment
  onEdit: () => void
}

export const RejectSmartActionPreview = ({ candidateEmailAction, onEdit }: Props) => {
  const [showContent, setShowContent] = useState(true)

  return (
    <CollapsableCard
      contentPadding="s16"
      contentBackground="grey200"
      open={showContent}
      Content={<RichTextDisplay content={candidateEmailAction.messageContent} />}
      Card={
        <>
          <Box width="full" flexDirection="row" justifyContent="spaceBetween" alignItems="center">
            <Box flexDirection="row" gap="s8" alignItems="center">
              <Icon.Small color="grey600" icon="small-envelope" />
              <Text.Normal weight="medium">
                {i18n.t('ats.smart_actions.rejection_card.title')}
              </Text.Normal>
            </Box>
            <Box flexDirection="row" gap="s8" alignItems="center">
              <Button type="secondary" onClick={onEdit} iconName="pencil" />
              <Touchable onClick={() => setShowContent(!showContent)}>
                <Chevron direction={showContent === true ? 'up' : 'down'} type="primary" />
              </Touchable>
            </Box>
          </Box>
          <Box width="full" paddingTop={'s12'} gap={'s4'}>
            <Box
              width="fit-content"
              background="grey400"
              paddingY={'s2'}
              paddingX={'s8'}
              borderRadius={{ all: 'abs008' }}
            >
              <Text.Normal weight="normal">{delayLabel(candidateEmailAction.delay)}</Text.Normal>
            </Box>
            <Box
              width="fit-content"
              background="grey400"
              paddingY={'s2'}
              paddingX={'s8'}
              borderRadius={{ all: 'abs008' }}
            >
              <Text.Normal weight="normal">
                {i18n.t('ats.smart_actions.rejection_card.sender', {
                  sender: sendFromLabel(candidateEmailAction.emailFrom),
                })}
              </Text.Normal>
            </Box>
          </Box>
        </>
      }
    />
  )
}
